import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ADPResourceService } from 'digital-core';
import { ChatHandler } from 'src/app/core/handler/chat-handler';
import { GoogleAnalyticsService } from 'src/app/core/services/google-tag-manager.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { AsappChatService } from '../../../../core/services/asapp-chat.service';

export interface IDeviceTypeTemplate {
  deviceTypeCode: string;
  deviceTypeDescription: string;
}

export enum ImeiInfoDeviceType {
  Smartphone = 'Smartphone',
  Smartwatch = 'Smartwatch',
  Tablet = 'Tablet',
}

@Component({
  selector: 'pgh-imei-info',
  templateUrl: './imei-info.component.html',
  styleUrls: ['./imei-info.component.scss'],
})
export class ImeiInfoComponent implements OnInit {
  @Output() closeEvent = new EventEmitter();
  @Output() letsChatClicked = new EventEmitter();
  @Input() imeiInfoDeviceType: ImeiInfoDeviceType;
  @Input() isDiagnosticInviteFlow?: boolean = false;
  public isChatAvailable = false;
  public isSmartphone: boolean = false;
  public isTablet: boolean = false;
  public isSmartwatch: boolean = false;
  public tabTitleiPhone: string = '';
  public tabTitleAndroid: string = '';
  public tabTitleiPad: string = '';
  public tabTitleAndroidTablet: string = '';
  public tabTitleApple: string = '';
  public tabTitleSamsung: string = '';
  public tabTitleGoogle: string = '';
  public tabTitleGarmin: string = '';
  public watchAppleGuide1ImageUrl: string = '';
  public watchAppleGuide1Alt: string = '';
  public watchAppleGuide2ImageUrl: string = '';
  public watchAppleGuide2Alt: string = '';
  public watchSamsungGuide1ImageUrl: string = '';
  public watchSamsungGuide1Alt: string = '';
  public watchGoogleGuide1ImageUrl: string = '';
  public watchGoogleGuide1Alt: string = '';
  public watchGoogleGuide1ImageUrlMobile: string = '';
  public watchGoogleGuide1AltMobile: string = '';
  public tabletiPadGuide1ImageUrl: string = '';
  public tabletiPadGuide1Alt: string = '';
  public tabletiPadGuide2ImageUrl: string = '';
  public tabletiPadGuide2Alt: string = '';
  public tabletiPadGuide3ImageUrl: string = '';
  public tabletiPadGuide3Alt: string = '';
  public tabletAndroidTabletGuide1ImageUrl: string = '';
  public tabletAndroidTabletGuide1Alt: string = '';
  public tabletAndroidTabletGuide2ImageUrl: string = '';
  public tabletAndroidTabletGuide2Alt: string = '';
  public phoneiPhoneGuide1ImageUrl: string = '';
  public phoneiPhoneGuide1Alt: string = '';
  public phoneiPhoneGuide2ImageUrl: string = '';
  public phoneiPhoneGuide2Alt: string = '';
  public phoneAndroidGuide1ImageUrl: string = '';
  public phoneAndroidGuide1Alt: string = '';
  public phoneAndroidGuide2ImageUrl: string = '';
  public phoneAndroidGuide2Alt: string = '';

  chatOffHoursStartTimeInUTC = '4';
  chatOffHoursEndTimeInUTC = '12';

  constructor(
    private matDialog: MatDialog,
    public route: ActivatedRoute,
    private utilityService: UtilityService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private resourceService: ADPResourceService,
    private activatedRoute: ActivatedRoute,
    private asappChatService: AsappChatService
  ) {}

  ngOnInit(): void {
    this.chatOffHoursStartTimeInUTC = this.resourceService.getPortalSetting('Chat_OffHours_StartTime_UTC24HT')?.Value ?? '4';
    this.chatOffHoursEndTimeInUTC = this.resourceService.getPortalSetting('Chat_OffHours_EndTime_UTC24HT')?.Value ?? '12';

    this.tabTitleiPhone = this.resourceService.getPortalLabel('IMEI_Info_Phones_iPhone_Title').Value;
    this.tabTitleAndroid = this.resourceService.getPortalLabel('IMEI_Info_Phones_Android_Title').Value;
    this.tabTitleiPad = this.resourceService.getPortalLabel('IMEI_Info_Tablets_iPad_Title').Value;
    this.tabTitleAndroidTablet = this.resourceService.getPortalLabel('IMEI_Info_Tablets_Android_Title').Value;
    this.tabTitleApple = this.resourceService.getPortalLabel('IMEI_Info_Watches_Apple_Title').Value;
    this.tabTitleSamsung = this.resourceService.getPortalLabel('IMEI_Info_Watches_Samsung_Title').Value;
    this.tabTitleGoogle = this.resourceService.getPortalLabel('IMEI_Info_Watches_Google_Title').Value;
    this.tabTitleGarmin = this.resourceService.getPortalLabel('IMEI_Info_Watches_Garmin_Title').Value;

    this.watchAppleGuide1ImageUrl = this.resourceService.getPortalImage('Global_IMEI_Info_Watches_Apple_Guide1').ImageURL;
    this.watchAppleGuide1Alt = this.resourceService.getPortalImage('Global_IMEI_Info_Watches_Apple_Guide1').Caption;
    this.watchAppleGuide2ImageUrl = this.resourceService.getPortalImage('Global_IMEI_Info_Watches_Apple_Guide2').ImageURL;
    this.watchAppleGuide2Alt = this.resourceService.getPortalImage('Global_IMEI_Info_Watches_Apple_Guide2').Caption;

    this.watchSamsungGuide1ImageUrl = this.resourceService.getPortalImage('Global_IMEI_Info_Watches_Samsung_Guide1').ImageURL;
    this.watchSamsungGuide1Alt = this.resourceService.getPortalImage('Global_IMEI_Info_Watches_Samsung_Guide1').Caption;

    this.watchGoogleGuide1ImageUrl = this.resourceService.getPortalImage('Global_IMEI_Info_Watches_Google_Guide1').ImageURL;
    this.watchGoogleGuide1Alt = this.resourceService.getPortalImage('Global_IMEI_Info_Watches_Google_Guide1').Caption;
    this.watchGoogleGuide1ImageUrlMobile = this.resourceService.getPortalImage('Global_IMEI_Info_Watches_Google_Guide1_Mobile').ImageURL;
    this.watchGoogleGuide1AltMobile = this.resourceService.getPortalImage('Global_IMEI_Info_Watches_Google_Guide1_Mobile').Caption;

    this.tabletiPadGuide1ImageUrl = this.resourceService.getPortalImage('Global_IMEI_Info_Tablets_iPad_Guide1').ImageURL;
    this.tabletiPadGuide1Alt = this.resourceService.getPortalImage('Global_IMEI_Info_Tablets_iPad_Guide1').Caption;
    this.tabletiPadGuide2ImageUrl = this.resourceService.getPortalImage('Global_IMEI_Info_Tablets_iPad_Guide2').ImageURL;
    this.tabletiPadGuide2Alt = this.resourceService.getPortalImage('Global_IMEI_Info_Tablets_iPad_Guide2').Caption;
    this.tabletiPadGuide3ImageUrl = this.resourceService.getPortalImage('Global_IMEI_Info_Tablets_iPad_Guide3').ImageURL;
    this.tabletiPadGuide3Alt = this.resourceService.getPortalImage('Global_IMEI_Info_Tablets_iPad_Guide3').Caption;

    this.tabletAndroidTabletGuide1ImageUrl = this.resourceService.getPortalImage('Global_IMEI_Info_Tablets_Android_Guide1').ImageURL;
    this.tabletAndroidTabletGuide1Alt = this.resourceService.getPortalImage('Global_IMEI_Info_Tablets_Android_Guide1').Caption;
    this.tabletAndroidTabletGuide2ImageUrl = this.resourceService.getPortalImage('Global_IMEI_Info_Tablets_Android_Guide2').ImageURL;
    this.tabletAndroidTabletGuide2Alt = this.resourceService.getPortalImage('Global_IMEI_Info_Tablets_Android_Guide2').Caption;

    this.phoneiPhoneGuide1ImageUrl = this.resourceService.getPortalImage('Global_IMEI_Info_Phones_iPhone_Guide1').ImageURL;
    this.phoneiPhoneGuide1Alt = this.resourceService.getPortalImage('Global_IMEI_Info_Phones_iPhone_Guide1').Caption;
    this.phoneiPhoneGuide2ImageUrl = this.resourceService.getPortalImage('Global_IMEI_Info_Phones_iPhone_Guide2').ImageURL;
    this.phoneiPhoneGuide2Alt = this.resourceService.getPortalImage('Global_IMEI_Info_Phones_iPhone_Guide2').Caption;

    this.phoneAndroidGuide1ImageUrl = this.resourceService.getPortalImage('Global_IMEI_Info_Phones_Android_Guide1').ImageURL;
    this.phoneAndroidGuide1Alt = this.resourceService.getPortalImage('Global_IMEI_Info_Phones_Android_Guide1').Caption;
    this.phoneAndroidGuide2ImageUrl = this.resourceService.getPortalImage('Global_IMEI_Info_Phones_Android_Guide2').ImageURL;
    this.phoneAndroidGuide2Alt = this.resourceService.getPortalImage('Global_IMEI_Info_Phones_Android_Guide2').Caption;

    if (this.imeiInfoDeviceType === ImeiInfoDeviceType.Smartphone) {
      this.isSmartphone = true;
    } else if (this.imeiInfoDeviceType === ImeiInfoDeviceType.Tablet) {
      this.isTablet = true;
    } else if (this.imeiInfoDeviceType === ImeiInfoDeviceType.Smartwatch) {
      this.isSmartwatch = true;
    }
    this.getLiveChatAvailability();
  }

  handleCloseSideNav() {
    this.closeEvent.emit('closed');
  }

  handleChatSupport() {
    this.closeEvent.emit('closed');
    this.letsChatClicked.emit();
    const rnWindow = window as any;
    if (rnWindow.ReactNativeWebView) {
      const message = JSON.stringify({ action: 'openChat', args: {} });
      rnWindow.ReactNativeWebView.postMessage(message);
    }

    // Show chat or not available dialog
    const chatHandler = new ChatHandler(this.matDialog, this.resourceService, this.utilityService, this.route, this.asappChatService);
    chatHandler.openChatInterface();
  }

  getLiveChatAvailability() {
    // check if chat bubble button is active, not being used in lower environments, let the default button click handle it
    // leaving for now for reference if needed later
    const button: HTMLElement = document.querySelector('.helpButtonEnabled');
    if (button) {
      // this only checks if we are within the active hours and set the flag to true or false
      const now = new Date();
      if (now.getUTCHours() >= parseInt(this.chatOffHoursStartTimeInUTC) && now.getUTCHours() < parseInt(this.chatOffHoursEndTimeInUTC)) {
        // if outside hours, chat is offline
        this.isChatAvailable = false;
      } else {
        // chat is online
        this.isChatAvailable = true;
      }
    } else {
      // if chat bubblde is not active, then chat is offline
      this.isChatAvailable = false;
    }
  }
}
